import React from 'react';
import Router from 'next/router';

export const Redirect = ({ url, delay = 0, onRedirect = undefined }) => {
  React.useEffect(() => {
    const timer = setTimeout(() => {
      Router.push(url);
      onRedirect && onRedirect();
    }, delay);

    return () => clearTimeout(timer);
  }, []);

  return null;
};
